// extracted by mini-css-extract-plugin
module.exports = {"backToTopWrapper":"pR","button":"pS"};